//

import React from 'react';

import Chip from '@mui/material/Chip';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  label: {
    padding: '2px 4px',
  },
}));

const StatusChip = (props) => {
  // eslint-disable-next-line react/prop-types
  const { label, sx = {} } = props;

  const { classes } = useStyles();

  return (
    <Chip
      classes={{ label: classes.label }}
      label={label}
      size='small'
      sx={(theme) => ({
        borderRadius: '6px',
        color: theme.palette.primary.main,
        fontSize: theme.typography.body2.fontSize,
        height: '100%',
        ...sx,
      })}
    />
  );
};

export default StatusChip;
